import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://cagqmhjfdxzdhpxjvdea.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNhZ3FtaGpmZHh6ZGhweGp2ZGVhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjUzODQ5MzEsImV4cCI6MjA4MDk2MDkzMX0.fnotzLPIBHYMXN7RoqA3wC6VBMNF9ZHrG5D6lqmtHvM'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables')
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})